/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyV2ExecutionRemediationAutoTrigger extends models.PolicyRemediationBase {
    getFixupPrototypeFunction() { return PolicyV2ExecutionRemediationAutoTrigger.fixupPrototype; }

    static newInstance(model: Partial<PolicyV2ExecutionRemediationAutoTrigger>): PolicyV2ExecutionRemediationAutoTrigger {
        let obj = Object.assign(new PolicyV2ExecutionRemediationAutoTrigger(), model);
        PolicyV2ExecutionRemediationAutoTrigger.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyV2ExecutionRemediationAutoTrigger>): PolicyV2ExecutionRemediationAutoTrigger {
        if (!model) return null;
        return PolicyV2ExecutionRemediationAutoTrigger.newInstance(<PolicyV2ExecutionRemediationAutoTrigger> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyV2ExecutionRemediationAutoTrigger) {
        if (!obj) return;

        models.PolicyV2ExecutionRemediationAutoTrigger.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyV2ExecutionRemediationAutoTrigger): boolean {
        if (models.PolicyRemediationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyV2ExecutionRemediationAutoTrigger.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * If true, the remediation action is automatically triggered once this policy execution completes.
     */
    enabled: boolean;

}
